<template>
  <static-fullscreen-card>
    <template v-slot:header></template>
    <template v-slot:actions>
      <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title> </v-btn>
      <v-btn color="primary" @click="createNew()" title="Создать элемент"><btn-title icon="far fa-plus-square">Создать</btn-title></v-btn>
    </template>
    <portal to="v-main">
      <edit-dialog v-model="showEditDialog" :id="idEdit" :api="url" :typeObject="objectType" :initData="initData"></edit-dialog>
      <s-edit-form-async ref="editField" />
      <s-editor-edit-field v-if="showEditField" v-model="showEditField" :values="editField.data" :model="editField.model" @commit="onCommitField($event)" />
      <DebugAvito ref="debugAvito"></DebugAvito>
    </portal>
    <a-table-f-api
      ref="table"
      :api="url"
      :model="model"
      :useQuery="false"
      :defaults="defaults"
      :selectedRows="selectedRows"
      @onEditField="onEditField($event)"
      @click="
        counter += 1;
        onDetectClick($event);
      "
    >
      <template v-slot:item.status_site="{ row }">
        <a-view-table-selectbit :values="row" :value="row['status_site']" :model="model.find((m) => m.name == 'status_site')" @clickItem="showDebug($event, row)" />
      </template>
      <template v-slot:item.actions="{ row }">
        <div class="d-flex">
          <v-btn v-if="row.link_ref" elevation="0" x-small fab class="ma-0 ml-1" color="green" title="Перейти по ссылке" @click.stop="openLink(row)">
            <v-icon>fas fa-external-link-alt</v-icon>
          </v-btn>
          <v-btn elevation="0" x-small fab class="ma-0 ml-1" color="grey" title="Создать копию" @click.stop="makeCopy(row)">
            <v-icon>fas fa-copy</v-icon>
          </v-btn>
          <v-btn
            elevation="0"
            :loading="!!(pdfLoading[objectType + '_' + row.id] && pdfLoading[objectType + '_' + row.id] == 1)"
            :disabled="!!pdfLoading[objectType + '_' + row.id]"
            x-small
            fab
            class="ma-0 ml-1"
            color="green"
            title="скачать"
            @click.stop="getPdf(row, 0)"
          >
            <v-icon>fas fa-file-export</v-icon>
          </v-btn>
          <v-btn v-if="false" elevation="0" x-small fab class="ma-0 ml-1" color="green" title="Просмотр" @click.stop="openLink(row, 1)">
            <v-icon>fas fa-eye</v-icon>
          </v-btn>
        </div>
      </template>
    </a-table-f-api>
  </static-fullscreen-card>
</template>

<script>
import { getAccess, keyDetect, doubleClickDetect, genModel } from "@/components/mixings";
import objects from "@/mixins/objects";
export default {
  mixins: [getAccess, keyDetect, doubleClickDetect, genModel, objects],
  components: {
    editDialog: () => import("./dialogs/objectsAgentDialog"),
    DebugAvito: () => import("./views/debugAvitoView"),
  },
  data() {
    return {
      idEdit: 0,
      showEditDialog: false,
      editField: null,
      showEditField: false,
      title: "",
      m: this.$store.getters["config/get"].models.objects,
      initData: null,
    };
  },
  created() {
    this.$root.title = this.$route.meta.title; //"Агентские объекты";
    //this.objectType = this.$route.meta.objectType;
  },
  computed: {
    defaults() {
      let res = {
        sort: { key: "id", order: "DESC" },
        filters: {},
        paramName: this.objectType,
      };

      if (this.getAccess("agentObjects.viewAll")) res.params = { viewAll: true };
      return res;
    },
    objectType() {
      return this.$route.meta.objectType;
    },
    config() {
      return this.m?.config?.[this.objectType] || {};
    },
    url() {
      return this.config.api;
    },

    model() {
      let res = this.getModelList(this.m, "listAgent", false);
      res.find((m) => m.name == "status").options = res.find((m) => m.name == "status").options.filter((s) => s.type == this.objectType);

      return res;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    openLink(row) {
      window.open(row.link_ref, "_blank");
    },
    onSingleClick(d) {},
    onDoubleClick(d) {
      this.onClickRow(d);
    },
    onClickRow(d) {
      if (d.field.name == "actions") return;
      this.$router.push({ name: this.config.viewName, params: { id: d.row.id } });
      // this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.initData = null;
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
    async makeCopy(r) {
      if (!r.id) return;
      let response;
      try {
        response = await this.$axios.get(this.url + "/" + r.id);
        let data = response.data.data;
        this.initData = data;
        this.showEditDialogFun(0);
      } catch (error) {}
    },
    showDebug(item, row) {
      if (item.name == "avito") {
        this.$refs.debugAvito.openAvito(row.data_avito);
      }
      if (item.name == "cian") {
        this.$refs.debugAvito.openCian(row.data_cian);
      }
    },
    onEditField(e) {
      if (!this.getAccess("site.edit")) return;
      let model = Object.assign({}, e.field);
      model.editField = model.name;
      model.name = "field";
      this.editField = { data: e.row, model: [model], row: e.row };
      this.showEditField = true;
    },
    async onCommitField(e) {
      if (e.name.split(".")[0] == "ads_data") {
        let ads_info = Object.assign({}, this.editField.data.ads_data);
        ads_info[e.name.split(".")[1]] = e.value;
        let id = this.editField.data.ads_id;
        if (!id) return;
        let data = { id, data: ads_info };
        console.log(data);
        let api = "mechti/object_props_value";
        await this.post(data, api);
        this.$refs.table.updateRowData(this.editField.data.id);
      } else {
        let data = { id: this.editField.row.id, [e.name]: e.value };
        let api = this.url; // this.types[this.objectType].url;
        if (data.id) await this.post(data, api);
        this.$refs.table.updateRowData(data.id);
      }
    },
    async post(data, api, silent = false) {
      this.loading = true;
      try {
        let response = await this.$axios.post(api, data);
        this.loading = false;
        if (response.data.data) {
          if (!silent)
            this.$root.$emit("show-info", {
              text: "Данные записаны",
            });
        }
      } catch (error) {
        console.log(error);
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при сохранении",
        });
        this.loading = false;
        return;
      }
    },
  },
};
</script>
